import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import {
  ApiClient,
  CreateFeedbackInput,
  CreateFeedbackInputKategorie,
  FeedbackResult
} from 'app/core/services/api-client/api-client';
import { ApiErrorHandlerService } from 'app/core/services/api-default-error-handler/api-error-handler.service';
import { CustomWindowService } from 'app/core/services/custom-window-service/custom-window.service';
import { CommonFeedbackComponent } from '../components/common-feedback/common-feedback.component';
import { WindowRef } from '@progress/kendo-angular-dialog';
import { I18nService } from 'app/core/services/i18n/i18n.service';

export interface CommonFeedbackDialogParams {
  description?: string;
  category?: CreateFeedbackInputKategorie;
  table?: string;
  value?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SharedFeedbackService {

  constructor(
    private apiClient: ApiClient,
    private errorHandler: ApiErrorHandlerService,
    private windowService: CustomWindowService,
    private i18n: I18nService,
  ) {}

  public create(feedback: CreateFeedbackInput): Observable<FeedbackResult> {
    return this.apiClient.apiFeedbackPost(feedback).pipe(
      catchError(
        this.apiClient.apiFeedbackPostErrorHandlers({
          error401Handler: error401 => this.errorHandler.handle401Error(error401),
        }),
      ),
    );
  }

  public clear(anhangUids: string[]): Observable<void> {
    return this.apiClient.apiFeedbackAnhangDelete(anhangUids).pipe(
      catchError(
        this.apiClient.apiFeedbackAnhangDeleteErrorHandlers({
          error401Handler: error401 => this.errorHandler.handle401Error(error401)
        })
      ),
    );
  }

  /**
   * Opens the Common Feedback dialog
   * @param params Parameters for the feedback dialog including subject, description, category, table, and value
   * @returns Observable that emits when the dialog is closed
   */
  public openCommonFeedbackDialog(params?: CommonFeedbackDialogParams): Observable<any> {
    const windowRef: WindowRef = this.windowService.openWindow({
      title: this.i18n.getLocalizedString('feedback.titles.system'),
      content: CommonFeedbackComponent,
      type: 'feedback',
    });

    // Set the component inputs if parameters are provided
    const componentInstance: CommonFeedbackComponent = windowRef.content.instance;
    
    if (params) {
      if (params.description) {
        componentInstance.createFeedback.beschreibung = params.description;
      }
      if (params.category) {
        componentInstance.createFeedback.kategorie = params.category;
      }
      if (params.table) {
        componentInstance.createFeedback.nachschlageTabelleName = params.table;
      }
      if (params.value) {
        componentInstance.createFeedback.nachschlageTabelleWert = params.value;
      }
    }

    return windowRef.result;
  }
}
